import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const CREATE_GOOGLE_AD_MANAGER_CONNECTION: TypedDocumentNode<Data, { input: Variables }> =
  gql`
    ${ERROR_FRAGMENT}

    mutation createGoogleAdManagerConnection($input: CreateGamConnectionOrderInput!) {
      createGamConnectionOrder(input: $input) {
        errors {
          ...ErrorFragment
        }
      }
    }
  `
